import type { WidgetPublicReview } from "@shared/contracts/widgets/public/common";
import { renderReviewCard } from "../components/reviewCard";
import type { Translator } from "../i18n/resolve";
import { escapeAttr } from "../utils/escape";

export type GridInput = {
  reviews: ReadonlyArray<WidgetPublicReview>;
  translate: Translator;
  now?: number;
};

export const renderGrid = ({ reviews, translate, now }: GridInput): string => {
  const items = reviews.map((review) => renderReviewCard({ review, translate, now })).join("");
  const label = escapeAttr(translate("wallLabel"));
  return `<section class="mbn-grid" role="region" aria-label="${label}">${items}</section>`;
};
